<div class="modal-header mainColor">
    <h6 class="modal-title text-center">{{"action_plan.problem_definition.modal.title" | translate}}</h6>
    <button type="button" class="close dangerButton" aria-label="Close" style="opacity: 1;" (click)="btnDismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="datosFormulario">
        <div class="form-row mb-2">
            <div class="col-lg-4">
                <label for="" class="label">{{"action_plan.problem_definition.modal.notice" | translate}}</label>
                <input type="number" min="0" class="form-control form-grey" formControlName="aviso" [ngClass]="{ 'error': datosFormulario.get('aviso').hasError('required')  &&
                datosFormulario.get('aviso').touched }">
            </div>
            <div class="col-lg-2">
                <label for="" class=" label">{{"action_plan.problem_definition.modal.unit" | translate}}</label>
                <span class="fa-stack fa-1x ml-lg-2 cursor invisible" style="font-size: 13px;">
                    <i class="fa fa-circle fa-stack-2x icon-background"></i>
                    <i class="fas fa-plus fa-stack-1x"></i>
                </span>
                <select class="form-control form-grey" formControlName="unidad" [ngClass]="{ 'error': datosFormulario.get('unidad').hasError('required')  &&
                datosFormulario.get('unidad').touched }">
                    <option value="1">{{"globals.days" | translate}}</option>
                    <option value="2">{{"globals.weeks" | translate}}</option>
                    <option value="4">{{"globals.months" | translate}}</option>
                    <option value="7">{{"globals.years" | translate}}</option>
                </select>
            </div>
            <div class="col-lg-6">
                <label for="" class=" label">{{"action_plan.problem_definition.modal.monetary_unit" |
                    translate}}</label>
                <span class="fa-stack fa-1x ml-lg-2 cursor invisible" style="font-size: 13px;">
                    <i class="fa fa-circle fa-stack-2x icon-background"></i>
                    <i class="fas fa-plus fa-stack-1x"></i>
                </span>
                <input type="text" class="form-control form-grey" formControlName="unidad_monetaria" [ngClass]="{ 'error': datosFormulario.get('unidad_monetaria').hasError('required')  &&
                datosFormulario.get('unidad_monetaria').touched }">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" ngbAutofocus class="btn dangerButton" (click)="btnDismiss()">{{"globals.buttons.cancelar" |
        translate}}</button>
    <button type="button" ngbAutofocus class="btn acceptButton" [disabled]="from" (click)="emitData()"
        (click)="btnClose()">{{"globals.buttons.accept" | translate}}</button>
</div>